// WebSocketService.js
import { w3cwebsocket as W3CWebSocket } from 'websocket'; // Make sure you install the 'websocket' package

const HOST = process.env.REACT_APP_WEBSOCKET_URL
const URI = `wss://${HOST}/api/v1/chat-stream`;

export const connectWebSocket = async (userInput, history, handleMessage) => {
    const request = {
        'user_input': userInput,
        'max_new_tokens': 250,
        'auto_max_new_tokens': false,
        'history': history,
        'mode': 'instruct',
        'character': 'Example',
        'instruction_template': 'Vicuna-v1.1',
        'your_name': 'You',
        'regenerate': false,
        '_continue': false,
        'chat_instruct_command': 'Continue the chat dialogue below. Write a single reply for the character "<|character|>".\n\n<|prompt|>',
        'preset': 'None',
        'do_sample': true,
        'temperature': 0.7,
        'top_p': 0.1,
        'typical_p': 1,
        'epsilon_cutoff': 0,
        'eta_cutoff': 0,
        'tfs': 1,
        'top_a': 0,
        'repetition_penalty': 1.18,
        'repetition_penalty_range': 0,
        'top_k': 40,
        'min_length': 0,
        'no_repeat_ngram_size': 0,
        'num_beams': 1,
        'penalty_alpha': 0,
        'length_penalty': 1,
        'early_stopping': false,
        'mirostat_mode': 0,
        'mirostat_tau': 5,
        'mirostat_eta': 0.1,
        'guidance_scale': 1,
        'negative_prompt': '',

        'seed': -1,
        'add_bos_token': true,
        'truncation_length': 2048,
        'ban_eos_token': false,
        'skip_special_tokens': true,
        'stopping_strings': []
    };

    try {
        const websocket = new W3CWebSocket(URI);
        websocket.onopen = () => {
            websocket.send(JSON.stringify(request));
        };

        websocket.onmessage = (event) => {
            const incomingDataJSON = JSON.parse(event.data);

            switch (incomingDataJSON.event) {
                case 'text_stream':
                    handleMessage(userInput, incomingDataJSON.history);
                    break;
                case 'stream_end':
                    return;
                default:
                    break;
            }
        };
    } catch (error) {
        console.error('WebSocket connection error:', error);
    }
};
